import { dataAttributeProps } from '@pbk-web/utils';
import type { FC, ReactElement } from 'react';

const IconBadge: FC<{ icon: ReactElement; text?: string | number; onClick?: () => void }> = (props) => {
  const { icon, text, onClick } = props;
  return (
    <div className={`bg-background-mid-2 inline-flex cursor-pointer flex-row items-center rounded-[5px] px-3 py-1`} onClick={onClick}>
      <div {...dataAttributeProps(props)} className="flex items-center gap-2">
        {icon}
        {text !== undefined && <span className="text-pbk-14 w-full text-center font-medium">{text}</span>}
      </div>
    </div>
  );
};

export default IconBadge;
